v-container
  //- Demographic Information Section
  v-row
    v-col(cols="12")
      h2.text-h4.mb-4 {{ $t('patient.demographic.title') }}

  v-row
    v-col(cols="12")
      v-text-field(
        v-model="form.name"
        :label="$t('patient.demographic.name')"
        :rules="[form.validCheck('name')]"
      )

  v-row
    v-col(cols="12" md="6")
      v-text-field(
        v-model="form.dateOfBirth"
        :label="$t('patient.demographic.dateOfBirth')"
        :rules="[form.validCheck('dateOfBirth')]"
      )

  //- Address fields
  AddressFields(:address="form.mailingAddress")

  v-row
    v-col(cols="12" md="6")
      v-text-field(
        v-model="form.cellPhone"
        :label="$t('patient.demographic.cellPhone')"
        type="tel"
        :rules="[form.validCheck('cellPhone')]"
      )
    v-col(cols="12" md="6")
      v-text-field(
        v-model="form.homePhone"
        :label="$t('patient.demographic.homePhone')"
        type="tel"
        :rules="[form.validCheck('homePhone')]"
      )

  v-row
    v-col(cols="12")
      v-text-field(
        v-model="form.email"
        :label="$t('patient.demographic.email')"
        type="email"
        :rules="[form.validCheck('email')]"
      )

  v-row
    v-col(cols="12" md="4")
      v-text-field(
        v-model="form.primaryCareDoctor"
        :label="$t('patient.demographic.primaryCareDoctor')"
        :rules="[form.validCheck('primaryCareDoctor')]"
      )
    v-col(cols="12" md="4")
      v-text-field(
        v-model="form.referringDoctor"
        :label="$t('patient.demographic.referringDoctor')"
        :rules="[form.validCheck('referringDoctor')]"
      )

  v-row
    v-col(cols="12" md="6")
      v-text-field(
        v-model="form.preferredPharmacy"
        :label="$t('patient.demographic.preferredPharmacy')"
        :rules="[form.validCheck('preferredPharmacy')]"
      )
    v-col(cols="12" md="6")
      v-text-field(
        v-model="form.preferredPharmacyLocation"
        :label="$t('patient.demographic.preferredPharmacyLocation')"
        :rules="[form.validCheck('preferredPharmacyLocation')]"
      )

  v-divider.my-6

  //- Eye History Section
  v-row
    v-col(cols="12")
      h2.text-h4.mb-4 {{ $t('patient.eyeHistory.title') }}

  v-row
    v-col(cols="12")
      v-radio-group(
        v-model="form.currentlyWear"
        :label="$t('patient.eyeHistory.currentlyWear')"
        :rules="[form.validCheck('currentlyWear')]"
        inline
      )
        v-radio(
          :label="$t('patient.eyeHistory.options.glasses')"
          value="Glasses"
        )
        v-radio(
          :label="$t('patient.eyeHistory.options.contactLenses')"
          value="Contact Lenses"
        )
        v-radio(
          :label="$t('patient.eyeHistory.options.neither')"
          value="Neither"
        )

  v-row
    v-col(cols="12")
      colored-radio-group(
        v-model="form.eyeMedications"
        :label="$t('patient.eyeHistory.eyeMedications')"
        :rules="[form.validCheck('eyeMedications')]"
        inline
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )

  //- Right Eye Surgery
  v-row
    v-col(cols="12")
      TypeIncidentInfoFields(
        :incident="form.rightEye"
        :label="$t('patient.eyeHistory.rightEyeSurgery')"
        :type-label="$t('patient.eyeHistory.surgeryType')"
        :when-label="$t('patient.eyeHistory.surgeryDate')"
        :add-label="$t('patient.eyeHistory.addSurgery')"
        :max-entries="2"
      )

  //- Left Eye Surgery
  v-row
    v-col(cols="12")
      TypeIncidentInfoFields(
        :incident="form.leftEye"
        :label="$t('patient.eyeHistory.leftEyeSurgery')"
        :type-label="$t('patient.eyeHistory.surgeryType')"
        :when-label="$t('patient.eyeHistory.surgeryDate')"
        :add-label="$t('patient.eyeHistory.addSurgery')"
        :max-entries="2"
      )

  v-divider.my-6

  //- Medical History Section
  v-row
    v-col(cols="12")
      h2.text-h4.mb-4 {{ $t('patient.medicalHistory.title') }}

  v-row
    v-col(cols="12" md="6")
      v-text-field(
        v-model="form.height"
        :label="$t('patient.medicalHistory.height')"
        :rules="[form.validCheck('height')]"
      )
    v-col(cols="12" md="6")
      v-text-field(
        v-model="form.weight"
        :label="$t('patient.medicalHistory.weight')"
        :rules="[form.validCheck('weight')]"
      )

  v-row
    v-col(cols="12")
      h3.text-h5.mb-4 {{ $t('patient.medicalHistory.conditionsTitle') }}

  //- Cardiovascular Disease Group
  v-row
    v-col(cols="12")
      h4.text-h6.mb-2 {{ $t('patient.medicalHistory.cardiovascular.title') }}

  IncidentInfoFields(
    :incident="form.heartAttack"
    :label="$t('patient.medicalHistory.cardiovascular.heartAttack')"
  )

  v-row
    v-col(cols="12")
      colored-radio-group(
        v-model="form.coronaryArteryDisease"
        :label="$t('patient.medicalHistory.cardiovascular.coronaryArteryDisease')"
        inline
        :rules="[form.validCheck('coronaryArteryDisease')]"
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )

  IncidentInfoFields(
    :incident="form.angina"
    :label="$t('patient.medicalHistory.cardiovascular.angina')"
  )

  IncidentInfoFields(
    :incident="form.chestPain"
    :label="$t('patient.medicalHistory.cardiovascular.chestPain')"
  )

  IncidentInfoFields(
    :incident="form.irregularHeartRate"
    :label="$t('patient.medicalHistory.cardiovascular.irregularHeartRate')"
  )

  IncidentInfoFields(
    :incident="form.palpitations"
    :label="$t('patient.medicalHistory.cardiovascular.palpitations')"
  )

  v-row
    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.congenitalHeartDisease"
        :label="$t('patient.medicalHistory.cardiovascular.congenitalHeartDisease')"
        inline
        :rules="[form.validCheck('congenitalHeartDisease')]"
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )
    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.rheumatoidHeartDisease"
        :label="$t('patient.medicalHistory.cardiovascular.rheumatoidHeartDisease')"
        inline
        :rules="[form.validCheck('rheumatoidHeartDisease')]"
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )

  IncidentInfoFields(
    :incident="form.murmur"
    :label="$t('patient.medicalHistory.cardiovascular.murmur')"
  )
  v-row
    v-col(cols="12")
      v-textarea(
        :label="$t('patient.medicalHistory.cardiovascular.cardioExplanation')" 
        v-model="form.cardioExplanation" 
        :rules="[form.validCheck('cardioExplanation')]" 
        rows="3"
      )
  v-divider.my-4

  //- Other Medical Conditions Group
  v-row
    v-col(cols="12")
      h4.text-h6.mb-2 {{ $t('patient.medicalHistory.other.title') }}

  v-row
    v-col(cols="12")
      colored-radio-group(
        v-model="form.respiratoryDisease"
        :label="$t('patient.medicalHistory.other.respiratoryDisease')"
        inline
        :rules="[form.validCheck('respiratoryDisease')]"
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )

  IncidentInfoFields(
    :incident="form.stroke"
    :label="$t('patient.medicalHistory.other.stroke')"
  )

  v-row
    v-col(cols="12")
      TypeIncidentInfoFields(
        :incident="form.heartSurgery"
        :label="$t('patient.medicalHistory.other.heartSurgery')"
        :type-label="$t('patient.medicalHistory.other.heartSurgeryType')"
        :when-label="$t('patient.medicalHistory.when')"
        :add-label="$t('patient.eyeHistory.addSurgery')"
      )

  IncidentInfoFields(
    :incident="form.pacemaker"
    :label="$t('patient.medicalHistory.other.pacemaker')"
  )

  IncidentInfoFields(
    :incident="form.aicd"
    :label="$t('patient.medicalHistory.other.aicd')"
  )

  v-row
    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.highBloodPressure"
        :label="$t('patient.medicalHistory.other.highBloodPressure')"
        inline
        :rules="[form.validCheck('highBloodPressure')]"
      )
        v-radio(:label="$t('common.yes')" :value="true")
        v-radio(:label="$t('common.no')" :value="false")
    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.sleepApnea"
        :label="$t('patient.medicalHistory.other.sleepApnea')"
        :rules="[form.validCheck('sleepApnea')]"
        inline
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )

  v-row
    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.anesthesiaDifficulty"
        :label="$t('patient.medicalHistory.other.anesthesiaDifficulty')"
        inline
        :rules="[form.validCheck('anesthesiaDifficulty')]"
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )
    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.bleedingDisorder"
        :label="$t('patient.medicalHistory.other.bleedingDisorder')"
        inline
        :rules="[form.validCheck('bleedingDisorder')]"
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )

  v-row
    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.liverDisease"
        :label="$t('patient.medicalHistory.other.liverDisease')"
        inline
        :rules="[form.validCheck('liverDisease')]"
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )
    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.kidneyDisease"
        :label="$t('patient.medicalHistory.other.kidneyDisease')"
        inline
        :rules="[form.validCheck('kidneyDisease')]"
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )

  v-row
    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.dialysis"
        :label="$t('patient.medicalHistory.other.dialysis')"
        inline
        :rules="[form.validCheck('dialysis')]"
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )
    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.diabetes"
        :label="$t('patient.medicalHistory.other.diabetes')"
        inline
        :rules="[form.validCheck('diabetes')]"
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )

  v-row
    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.thyroidDisease"
        :label="$t('patient.medicalHistory.other.thyroidDisease')"
        inline
        :rules="[form.validCheck('thyroidDisease')]"
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )
    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.cancer"
        :label="$t('patient.medicalHistory.other.cancer')"
        inline
        :rules="[form.validCheck('cancer')]"
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )

    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.bigbmi"
        :label="$t('patient.medicalHistory.other.bigbmi')"
        inline
        :rules="[form.validCheck('bigbmi')]"
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )
  v-row
    v-col(cols="12")
      v-textarea(
        :label="$t('patient.medicalHistory.other.otherExplanation')" 
        v-model="form.otherExplanation" 
        :rules="[form.validCheck('otherExplanation')]" 
        rows="3"
      )

  v-divider.my-6

  //- Medications Section
  v-row
    v-col(cols="12")
      h2.text-h4.mb-4 {{ $t('patient.meds.title') }}

  v-row
    v-col(cols="12" md="6")
      v-radio-group(v-model="form.medicationListUploadType" :label="$t('patient.meds.medicationList')" :rules="[form.validCheck('medicationListUploadType')]" inline)
        v-radio(label="Text input" value="text")
        v-radio(label="Upload file" value="file")
      if form.medicationListUploadType == 'text'
        v-textarea(v-model="form.medicationListText" :rules="[form.validCheck('medicationListText')]" rows="3")
      else 
        v-file-upload(clearable v-model="form.medicationListFile" :rules="[form.validCheck('medicationListFile')]")

  v-divider.my-6

  //- Allergies Section
  v-row
    v-col(cols="12")
      h2.text-h4.mb-4 {{ $t('patient.allergies.title') }}

  v-row
    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.medicationAllergies"
        :rules="[form.validCheck('medicationAllergies')]"
        :label="$t('patient.allergies.medicationAllergies')"
        inline
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )
    v-col(cols="12" md="6")
      colored-radio-group(
        v-model="form.latexAllergy"
        :rules="[form.validCheck('latexAllergy')]"
        :label="$t('patient.allergies.latexAllergy')"
        inline
      )
        v-radio(
          :label="$t('common.yes')"
          :value="true"
        )
        v-radio(
          :label="$t('common.no')"
          :value="false"
        )
  v-row
    v-col(cols="12" md="6")
      v-textarea(
        v-model="form.allergiesListText"
        :label="$t('patient.allergies.allergiesList')"
      )

  v-divider.my-6

  //- Review of Symptoms Section
  v-row
    v-col(cols="12")
      h2.text-h4.mb-4 {{ $t('patient.reviewOfSymptoms.title') }}
      p.text-subtitle-1 {{ $t('patient.reviewOfSymptoms.description') }}

  v-row
    v-col(cols="12" md="6")
      v-checkbox(
        v-model="form.heart"
        :label="$t('patient.reviewOfSymptoms.heart')"
        :rules="[form.validCheck('heart')]"
      )
    v-col(cols="12" md="6")
      v-checkbox(
        v-model="form.respiratory"
        :label="$t('patient.reviewOfSymptoms.respiratory')"
        :rules="[form.validCheck('respiratory')]"
      )

  v-row
    v-col(cols="12" md="6")
      v-checkbox(
        v-model="form.earNoseThroat"
        :label="$t('patient.reviewOfSymptoms.earNoseThroat')"
        :rules="[form.validCheck('earNoseThroat')]"
      )
    v-col(cols="12" md="6")
      v-checkbox(
        v-model="form.gastrointestinal"
        :label="$t('patient.reviewOfSymptoms.gastrointestinal')"
        :rules="[form.validCheck('gastrointestinal')]"
      )

  v-row
    v-col(cols="12" md="6")
      v-checkbox(
        v-model="form.urinary"
        :label="$t('patient.reviewOfSymptoms.urinary')"
        :rules="[form.validCheck('urinary')]"
      )
    v-col(cols="12" md="6")
      v-checkbox(
        v-model="form.hematologicLymphatic"
        :label="$t('patient.reviewOfSymptoms.hematologicLymphatic')"
        :rules="[form.validCheck('hematologicLymphatic')]"
      )

  v-row
    v-col(cols="12" md="6")
      v-checkbox(
        v-model="form.endocrine"
        :label="$t('patient.reviewOfSymptoms.endocrine')"
        :rules="[form.validCheck('endocrine')]"
      )
    v-col(cols="12" md="6")
      v-checkbox(
        v-model="form.integumentary"
        :label="$t('patient.reviewOfSymptoms.integumentary')"
        :rules="[form.validCheck('integumentary')]"
      )

  v-row
    v-col(cols="12" md="6")
      v-checkbox(
        v-model="form.musculoskeletal"
        :label="$t('patient.reviewOfSymptoms.musculoskeletal')"
        :rules="[form.validCheck('musculoskeletal')]"
      )
    v-col(cols="12" md="6")
      v-checkbox(
        v-model="form.neurological"
        :label="$t('patient.reviewOfSymptoms.neurological')"
        :rules="[form.validCheck('neurological')]"
      )

  v-row
    v-col(cols="12" md="6")
      v-checkbox(
        v-model="form.psychiatric"
        :label="$t('patient.reviewOfSymptoms.psychiatric')"
        :rules="[form.validCheck('psychiatric')]"
      )
    v-col(cols="12" md="6")
      v-checkbox(
        v-model="form.allergicImmunologic"
        :label="$t('patient.reviewOfSymptoms.allergicImmunologic')"
        :rules="[form.validCheck('allergicImmunologic')]"
      )

  v-divider.my-6

  //- Social History Section
  v-row
    v-col(cols="12")
      h2.text-h4.mb-4 {{ $t('patient.socialHistory.title') }}

  v-row
    v-col(cols="12" md="6")
      v-select(
        v-model="form.alcohol"
        :label="$t('patient.socialHistory.alcohol')"
        :items="['Never', 'Rarely', 'Moderately', 'Daily']"
        :rules="[form.validCheck('alcohol')]"
      )
    v-col(cols="12" md="6")
      v-select(
        v-model="form.tobacco"
        :label="$t('patient.socialHistory.tobacco')"
        :items="['Never', 'Rarely', 'Moderately', 'Daily']"
        :rules="[form.validCheck('tobacco')]"
      )

  v-divider.my-6

  //- Family History Section
  FamilyHistoryTable(:family-history="form.familyHistory")

  v-divider.my-6

  //- Signature Section
  v-row
    v-col(cols="12")
      h2.text-h4.mb-4 {{ $t('patient.signature.title') }}

  v-row
    v-col(cols="12")
      SignaturePad(
        v-model="form.signature"
        :label="$t('patient.signature.label')"
          :rules="[form.validCheck('signature')]"
      )
